// extracted by mini-css-extract-plugin
module.exports = {"stickyColHead":"MargenesPrecio_stickyColHead__1goJL","stickyCol":"MargenesPrecio_stickyCol__1FuFi"};